import currentUserStore from 'stores/CurrentUserStore';
import {
  BIN_DATA_MANAGEMENT_VIEW,
  BIN_DATA_MANAGEMENT_VIEW_AND_EDIT,
} from '@mqd/mqd-constants/src/uamGranularPermissions';

export const requirements = {
  flipFlopRequirements: ['bin-management-active'],
  requiredUserPermissions: [
    BIN_DATA_MANAGEMENT_VIEW,
    BIN_DATA_MANAGEMENT_VIEW_AND_EDIT,
    'Customer Success',
    'Program Management',
    'Delivery (Internal)',
  ],
  marqetaOnly: true,
};

export const verifier = () => {
  const { userStore = {} } = currentUserStore;
  const { canViewBinManagement } = userStore;

  return canViewBinManagement;
};
